module.exports = __webpack_public_path__ + "static/media/whooo.a7f63664.wav";